import { infiniteQueryOptions } from '@tanstack/react-query'

import { fetchLibraryPage, type MediaKind } from '#admin/features/media-library/api.ts'

/**
 * The library page's rows.
 *
 * **Under `['cms', 'media-library']`**, the picker's prefix, so one invalidation reaches both:
 * a crop saved from a field refreshes this table, and an upload here refreshes an open picker.
 *
 * Fresh for four minutes, as the picker is: each row carries a five-minute thumbnail URL, and a
 * table revisited after that would draw broken images.
 */
export const libraryPageQuery = (q: string, kind: MediaKind) =>
  infiniteQueryOptions({
    queryKey: ['cms', 'media-library', 'page', kind, q],
    queryFn: ({ pageParam, signal }) => fetchLibraryPage({ q, kind, cursor: pageParam }, signal),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    staleTime: 4 * 60 * 1000,
  })
